import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const changeLogsApi = createApi({
  reducerPath: "changeLogsApi",
  baseQuery: fetchBaseQuery({
    baseUrl: BASE_URL,
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      if (token) {
        headers.set("authorization", `Bearer ${token}`);
      }
      return headers;
    },
  }), 
  tagTypes: ["ChangeLogs"],

  endpoints: (builder) => ({ 
    getCarChangeLogs: builder.query({
      query: () => ({
        url: "/Sale/all-car-changes",
        method: "GET",
      }),
      providesTags: ["ChangeLogs"],
    }),
  }),
});
 
export const { useGetCarChangeLogsQuery } = changeLogsApi;